<template>
    <el-dialog title="搜索聊天记录" :visible.sync="searchdata" width="900px" class="searchdialog" :before-close="searchclose">
        <div class="searchhis">
            <i class="iconfont">&#xe7ce;</i>
            <input type="text" placeholder="搜索" v-model="searchValue" @change="searchfriend">
            <a href="javascript:;" @click="searchclear" v-show="inputFocus">
                <i class="iconfont">&#xe6a8;</i>
            </a>
        </div>
        <div class="searchresult clearfix" v-loading="loading">

            <div v-if="searchlist.records &&searchlist.records.length != 0">
                <div class="result_l">
                    <div class="result_lcon">
                        <el-scrollbar style="height: 100%;">
                            <ul>
                                <li class="clearfix" :class="{'active':info.sid == item.id}" v-for="(item,index) in searchlist.records" :key="index" @click="searchhis(item.id,item.nickname,item.avatar)">
                                    <el-avatar class="avatar" :size="40" :src="item.avatar"></el-avatar>
                                    <div class="result_info">
                                        <p>{{ item.nickname }}</p>
                                        <span>{{item.searchChatCount}}条相关聊天记录</span>
                                    </div>
                                </li>
                                <!-- <li class="clearfix" @click="searchhis(66)">
                                    <el-avatar class="avatar" :size="40" src="http://wx.qlogo.cn/mmhead/ver_1/gc7FSVBxJKX12Lbrk4LCdibV4HOqLLibr0CI4muoPDoG0M82ic4grR8G76n5wHmPibWtJvz3qwC6zibXaDJAeQZQMQD6pURZayZKz5ibbzjXqSTQI/96"></el-avatar>
                                    <div class="result_info">
                                        <p>我是前端假数据</p>
                                        <span>新又还是坏事？</span>
                                    </div>
                                </li> -->
                            </ul>
                        </el-scrollbar>
                    </div>
                </div>
                <div class="result_r">
                    <!--  -->
                    <searchatresult :searchValue="searchValue" :info="info" timerange=""></searchatresult>

                </div>
            </div>
            <p class="empty" v-if="searchValue == ''">输入关键词进行搜索</p>
            <p class="empty" v-if="searchlist.records &&searchlist.records.length == 0">搜不到？换个关键词试试</p>
        </div>
        <!-- <span slot="footer" class="dialog-footer">
            <el-button @click="searchdata = false">取 消</el-button>
            <el-button type="primary" @click="searchdata = false">确 定</el-button>
        </span> -->
    </el-dialog>
</template>

<script>
    import {
        searchMessageContactinfo,
        searchMessage
    } from '@/utils/api-im.js'
    import {
        mapGetters
    } from 'vuex'
    import searchatresult from './searchatresult'
    export default {
        name: 'searchchathistory',
        data() {
            return {
                searchValue: '',
                timeout: null,
                inputFocus: false,
                searchlist:[],
                sid:'',
                info:'',
                loading:true
            }
        },
        components:{
            searchatresult
        },
        computed: {
            ...mapGetters('im', [
                'selTeam'
            ])
        },
        props: {
            searchdata: {}
        },
        watch: {
            searchdata() {
                console.log('12')
                this.searchValue = sessionStorage.getItem('searchValue')
                this.searchfriend(this.searchValue)
            },
            searchValue(nval,oval) {
                clearTimeout(this.timeout);
                this.timeout = setTimeout(() => {
                    this.searchfriend(nval);
                }, 300);

            }
        },
        methods: {
            searchclose() {
                console.log('closesearchhistory')
                this.$emit('closesearchhistory')
                this.searchValue = ''
            },
            searchclear(){
                this.searchValue = ''
            },
            searchfriend(nval) {
                this.loading =true
                console.log(nval,'nval')
                if(nval){
                    this.inputFocus = true
                    console.log(nval,'sssssss')
                    this.$post(searchMessageContactinfo,{
                        content:this.searchValue,
                        queryListGroupType:this.selTeam.type,
                        wechatid:this.selTeam.id
                    }).then(res=>{
                        console.log(res.data)
                        if(res.data.code == 200){
                            if(res.data.data !=''){
                                this.searchlist = res.data.data
                            }else{
                                this.searchlist = {
                                    records:[]
                                }
                            }

                        }
                        this.loading =false
                    })
                }else{
                    this.inputFocus = false
                    this.searchlist = {}
                    this.loading =false
                    return false
                }
            },
            searchhis(id,nickname,avatar){
                console.log(id,'id')
                this.info = {
                    sid:id,
                    avatar:avatar,
                    nickname:nickname
                }
            }
        }
    }
</script>
<style lang="less" scoped>
    .searchresult{
        border-top: 1px solid #E7EBF3;
        margin: 20px 10px 0px;
        height: 480px;

        .result_r{
            float: left;
            padding: 13px 0px 13px 30px;
            height: 435px;
            width: calc(100% - 230px);
        }

        .result_l{
            position: relative;
            width: 200px;
            height: 435px;
            float: left;

            .result_lcon{
                position: absolute;
                left: -30px;
                top: 0;
                width: 230px;
                height: 475px;
                border-right: 1px solid #E7EBF3;

                li{
                    height: 40px;
                    padding:12px 10px 14px 30px;
                    cursor: pointer;

                    .avatar{
                        float: left;
                    }

                    &.active{
                        background: #F3F3F4;
                    }

                    .result_info{
                        float: left;
                        margin-left: 12px;

                        p{
                            color: #2A2A2A;
                            font-size: 14px;
                            width: 130px;
                            margin: 5px 0;
                            height: 14px;
                            white-space: nowrap;
                            overflow: hidden;
                            text-overflow: ellipsis;
                        }

                        span{
                            font-size: 12px;
                            color: #93999F;
                        }
                    }
                }
            }
        }
    }

    .empty{
        margin-top: 80px;
        text-align: center;
        color: #93999F;
    }
    .searchhis {
        padding-left: 38px;
        margin: 0 15px 10px;
        height: 36px;
        background: rgba(248, 249, 250, 1);
        border: 1px solid rgba(233, 235, 236, 1);
        position: relative;
        border-radius: 18px;
        z-index: 1;

        input {
            width: 100%;
            height: 36px;
            line-height: 36px;
            background: transparent;
            font-size: 14px;
        }

        i {
            position: absolute;
            left: 17px;
            top: 11px;
            font-size: 18px;
        }

        a {
            position: absolute;
            right: 50px;
            top: 0px;
        }
    }

</style>
<style>
    .searchdialog .el-dialog__header {
        display: block;
    }
    .searchresult .el-main{
        padding: 0;
        overflow: hidden;
    }
</style>



// WEBPACK FOOTER //
// src/views/customerservice/components/searchchathistory.vue